import { SaveScheduledPickupRequest } from 'src/app/core/models/operations/operations-pickup.model';

export const CONSTANTS = {
  NEW_PICKUP_HEADER: $localize`Pickup Request Details`,
  SCHEDULED_PICKUP_HEADER: $localize`Scheduled Pickup Details`,
  SCHEDULING_SUBHEADER: $localize`Scheduling`,
  CUSTOMER_SUBHEADER: $localize`Customer Information`,
  ON_DEMAND_PICKUP: $localize`OnDemand Pickup`,
  DATE_ASSIGNED: $localize`Days Assigned:`,
  PICKUP_REQUEST_NUMBER: $localize`Pickup Request #`,
  PICKUP_POINT: $localize`Pickup Point`,
  ROUTE: $localize`Route`,
  START_DATE: $localize`Start Date`,
  END_DATE: $localize`End Date`,
  DATE_PLACEHOLDER: $localize`MM / DD / YYYY`,
  READY_TIME: $localize`Ready Time`,
  COMMIT_TIME: $localize`Commit Time`,
  CLOSING_TIME: $localize`Closing Time`,
  TIME_PLACEHOLDER: '00:00',
  INTERRUPT_DATE: $localize`Interrupt Date`,
  RESTART_DATE: $localize`Restart Date`,
  SHIPPER_NUMBER: $localize`Shipper Number`,
  CUSTOMER_NAME: $localize`Customer Name`,
  CONTACT_NAME: $localize`Contact Name`,
  CONTACT_NUMBER: $localize`Contact #`,
  STREET_ADDRESS: $localize`Street Address`,
  PREFIX: $localize`Prefix`,
  STREET_NAME: $localize`Street Name`,
  SUFFIX: $localize`Suffix`,
  SUITE: $localize`Suite`,
  FLOOR: $localize`Floor`,
  CITY: $localize`City/Town`,
  PROVINCE: $localize`Province`,
  POSTAL_CODE: $localize`Postal Code`,
  LATITUDE: $localize`Latitude`,
  LONGITUDE: $localize`Longitude`,
  NOTES: $localize`Notes`,
  SSC_DESCRIPTION: $localize`SSC Description`,
  ADDITIONAL_INFORMATION: $localize`Additional Information`,
  ADDITIONAL_INFORMATION_PLACEHOLDER: $localize`Enter Additional Information`,
  VALIDATE: $localize`Validate`,
  SAVE: $localize`Save`,
};

export const MOCK_SCHEDULED_PICKUP_REQUEST: SaveScheduledPickupRequest = {
  schedulePickup: {
    id: 0,
    ondemandPickUp: false,
    daysAssigned: {
      sunday: false,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
    },
    pickupRequest: '',
    pickupPoint: 'Garage',
    route: 'AD2',
    startDate: '2021-02-02',
    endDate: '2099-12-31',
    readyTime: '15:00',
    commitTime: '17:00',
    closingTime: '17:00',
    interruptDate: '',
    restartDate: '',
    customerInfo: {
      shipperNo: '12345',
      customerName: 'Michael',
      contactName: 'Scott',
      contactNumber: '1234567890',
      streetAddress: '12',
      prefix: 'PF',
      streetName: 'Dunder Miflin',
      suffix: 'SF',
      suite: '1',
      floor: '2',
      cityTown: 'Scranton',
      province: 'PA',
      postalCode: '01234',
      latitude: '1.1.10',
      longitude: '1.1.10',
    },
    additionalInfo: '',
    SSCDescription: '',
  },
};

export const PICKUPS = {
  ON_DEMAND_PICKUP: 'ondemandPickUp',
  DAYS_ASSIGNED: 'daysAssigned',
  PICKUP_REQUEST_NUMBER: 'pickupRequestNumber',
  PICKUP_POINT: 'pickupPoint',
  ROUTE: 'route',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  READY_TIME: 'readyTime',
  COMMIT_TIME: 'commitTime',
  CLOSING_TIME: 'closingTime',
  INTERRUPT_DATE: 'interruptDate',
  RESTART_DATE: 'restartDate',
  SHIPPER_NUMBER: 'shipperNumber',
  CUSTOMER_NAME: 'customerName',
  CONTACT_NAME: 'contactName',
  CONTACT_NUMBER: 'contactNumber',
  STREET_ADDRESS: 'streetAddress',
  PREFIX: 'prefix',
  STREET_NAME: 'streetName',
  SUFFIX: 'suffix',
  SUITE: 'suite',
  FLOOR: 'floor',
  CITY: 'city',
  PROVINCE: 'province',
  POSTAL_CODE: 'postalCode',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  SSC_DESCRIPTION: 'sscDescription',
  ADDITIONAL_INFORMATION: 'additionalInfo',
};
